import { render } from "./Scrollable.vue?vue&type=template&id=57982b05"
import script from "./Scrollable.vue?vue&type=script&lang=js"
export * from "./Scrollable.vue?vue&type=script&lang=js"

import "./Scrollable.vue?vue&type=style&index=0&id=57982b05&lang=scss"

import exportComponent from "../../../../../DIARC/pixonanimation.az/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__